import { createFileRoute } from '@tanstack/react-router'
import { HelpSectionScreen } from '../../../features/help/screens'
import { helpGuidesQuery } from '../../../features/help/use-help'
import { helpViewerQuery } from '../../../features/help/viewer'

/** /help/<section>. Owner: slice 36 `web-help-centre`. */
export const Route = createFileRoute('/help/$section/')({
  loader: async ({ context }) => {
    const viewer = await context.queryClient.ensureQueryData(helpViewerQuery())
    await context.queryClient.ensureQueryData(helpGuidesQuery(viewer))
  },
  component: SectionRoute,
})

function SectionRoute() {
  const { section } = Route.useParams()
  return <HelpSectionScreen section={section} />
}
